module.exports = __webpack_public_path__ + "static/divyaa-bc9e85d6a719c391785cfcf27f3f1cf9.jpg";